import BackButton from "../BackButton";
import classes from "./styles.module.scss";
import Title from "@/ui/Title";
import * as moment from 'moment';

export default function InsightHero({ title, tags, publish_date }) {

  function formatDate() {
    const today = moment.default();
    const publishDate = moment.default(publish_date);
    return today.diff(publishDate, 'days');
  }

  return (
    <div className={classes.hero}>
      <div className={classes.content}>
        <BackButton page="Insights" link="/blogs" />
        <Title title={title} tag="h1" className={classes.title} />
      </div>
      <div className={classes.details}>
        <div className={classes.tags}>
          {
            tags.map((tag, index) => {
              return <div key={index} className={classes.tag}>{tag}</div>
            })
          }
        </div>
        <div className={classes.date}>Posted {formatDate()} days ago</div>
      </div>
    </div>
  );
}